var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	53858: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(78281))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	97102: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(8568))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	94978: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(82404))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "2.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@grafana/faro-web-sdk",

	},
	5839: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(78041))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.39.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-query",

	},
	12794: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(79865))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^11.18.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	14234: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(57310))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "setimmediate",

	},
	37166: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(44599))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "2.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@grafana/faro-react",

	},
	51253: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(93805))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.4.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	63866: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(136)]).then(() => (() => (__webpack_require__(32977))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "5.14.10",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mui/styles",

	},
	73754: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(90715))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "2.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@grafana/faro-web-tracing",

	},
	85260: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(136), __webpack_require__.e(602), __webpack_require__.e(970)]).then(() => (() => (__webpack_require__(60714))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "5.14.10",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mui/material",

	},
	95602: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(59431))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "11.10.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	91136: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(43979))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^15.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "prop-types",

	},
	89970: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(56272))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "11.10.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/styled",

	},
	16346: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(867)]).then(() => (() => (__webpack_require__(28724))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "3.1.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/op-eventbus-sdk",

	},
	74415: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(7188))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.6.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/web-support-sdk",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"102": [
		97102
	],
	"136": [
		91136
	],
	"307": [
		5839,
		12794,
		14234,
		37166,
		51253,
		63866,
		73754,
		85260
	],
	"602": [
		95602
	],
	"858": [
		53858
	],
	"888": [
		16346,
		74415
	],
	"970": [
		89970
	],
	"978": [
		94978
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}